export const normalizeSepaResults = (data) => {
  if (Array.isArray(data.sepa_files_by_entity)) {
    return data.sepa_files_by_entity
  }

  const legacyFiles = Array.isArray(data.sepa_files)
    ? data.sepa_files
    : (data.sepa_file ? [data.sepa_file] : [])

  return legacyFiles.map((file) => ({
    billing_entity_id: null,
    billing_entity_code: 'Legacy',
    status: 'created',
    file,
    transaction_count: null,
    control_sum: null,
    message: 'SEPA file created.',
  }))
}

export const sepaStatusColor = (status) => {
  if (status === 'created') return 'success'
  if (status === 'failed') return 'danger'
  return 'secondary'
}

export const formatControlSum = (value) => (
  value === null || typeof value === 'undefined'
    ? '-'
    : Number(value).toFixed(2)
)
